<div class="order-success-container">
  <!-- Success Graphic -->
  <div
    id="success-lottie"
    style="width: 300px; height: 300px"
    class="mx-auto"
  ></div>

  <!-- Main Heading -->
  <h1 class="main-heading">
    Your Order Has Been Placed! We'll Keep You Posted.
  </h1>

  <!-- Order Number -->
  <div class="order-number-container flex items-center ">
   
    <span class="order-number">#{{ orderNumber }}</span>
  </div>

  <!-- Expected Delivery -->
  <div class="delivery-info">Expected Delivery: {{ expectedDelivery }}</div>

  <!-- Action Buttons -->
  <div class="action-buttons">
    <button
      class="btn bg-blue-dark text-white-color"
      (click)="downloadWaybill( )"
    >
      Download Waybill
    </button>
    <button
      class="btn bg-blue-theme-color text-white-color"
      (click)="viewOrderDetail()"
    >
      Order Detail
    </button>
  </div>
</div>
